var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['header', _vm.isScrolled ? 'scrolled' : null]
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/images/logo/logo-svg.svg",
      "alt": "tamayoz-logo",
      "width": "32px"
    }
  })]), !_vm.isAuthPages ? _c('div', [_vm.isAuth ? [_c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.handleOutside,
      expression: "handleOutside"
    }],
    staticClass: "zadi-dropdown"
  }, [_c('div', {
    staticClass: "wrapper",
    on: {
      "click": function ($event) {
        _vm.dropdownStatus = !_vm.dropdownStatus;
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userName))]), _vm._m(0)])])] : _vm._e(), _c('global-search')], 2) : _vm._e()], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../public/assets/images/website/zadi/avatar-1.png")
    }
  })]);
}]

export { render, staticRenderFns }